<template>
  <div class="fixed top-4 right-4 z-[10000] space-y-2 w-[calc(100vw-2rem)] max-w-sm sm:w-auto">
    <TransitionGroup name="notification" tag="div" class="space-y-2">
      <!-- Errors -->
      <div
        v-for="error in errors"
        :key="`err-${error.id}`"
        class="relative overflow-hidden flex items-start gap-2 bg-red-50 dark:bg-red-950/40 border border-red-300 dark:border-red-800 text-red-700 dark:text-red-300 px-4 py-3 rounded-lg shadow-lg backdrop-blur-sm"
        role="alert"
      >
        <ExclamationTriangleIcon class="w-5 h-5 flex-shrink-0 mt-0.5" />
        <span class="text-sm flex-1 min-w-0 break-words">{{ error.message }}</span>
        <button
          @click="removeError(error.id)"
          class="text-red-600 hover:text-red-800 dark:text-red-400 dark:hover:text-red-200 transition-colors flex-shrink-0"
          aria-label="Cerrar notificación"
        >
          <XMarkIcon class="w-4 h-4" />
        </button>
        <span
          v-if="error.duration"
          class="toast-progress bg-red-400/70 dark:bg-red-500/60"
          :style="{ animationDuration: `${error.duration}ms` }"
          aria-hidden="true"
        />
      </div>

      <!-- Successes -->
      <div
        v-for="success in successes"
        :key="`ok-${success.id}`"
        class="relative overflow-hidden flex items-start gap-2 bg-emerald-50 dark:bg-emerald-950/40 border border-emerald-300 dark:border-emerald-800 text-emerald-700 dark:text-emerald-300 px-4 py-3 rounded-lg shadow-lg backdrop-blur-sm"
        role="status"
      >
        <CheckCircleIcon class="w-5 h-5 flex-shrink-0 mt-0.5" />
        <span class="text-sm flex-1 min-w-0 break-words">{{ success.message }}</span>
        <button
          @click="removeSuccess(success.id)"
          class="text-emerald-600 hover:text-emerald-800 dark:text-emerald-400 dark:hover:text-emerald-200 transition-colors flex-shrink-0"
          aria-label="Cerrar notificación"
        >
          <XMarkIcon class="w-4 h-4" />
        </button>
        <span
          v-if="success.duration"
          class="toast-progress bg-emerald-400/70 dark:bg-emerald-500/60"
          :style="{ animationDuration: `${success.duration}ms` }"
          aria-hidden="true"
        />
      </div>
    </TransitionGroup>
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { ExclamationTriangleIcon, CheckCircleIcon, XMarkIcon } from '@heroicons/vue/24/outline'
import { useAppStore } from '@/stores/app'

const appStore = useAppStore()
const { errors, successes } = storeToRefs(appStore)
const { removeError, removeSuccess } = appStore
</script>

<style scoped>
.notification-enter-active,
.notification-leave-active {
  transition: all 0.35s ease;
}

.notification-enter-from {
  opacity: 0;
  transform: translateX(100%);
}

.notification-leave-to {
  opacity: 0;
  transform: translateX(100%);
}

.notification-move {
  transition: transform 0.35s ease;
}

.toast-progress {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 3px;
  transform-origin: left;
  animation-name: toast-progress;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
}

@keyframes toast-progress {
  from { transform: scaleX(1); }
  to { transform: scaleX(0); }
}
</style>
